
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guidelines/rate-limiting",
      function () {
        return require("private-next-pages/guidelines/rate-limiting/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guidelines/rate-limiting"])
      });
    }
  